(function(root,factory){var state=factory();if(typeof module==='object'&&module.exports)module.exports=state;else root.UNIFYShippingState=state;})(typeof window==='undefined'?globalThis:window,function(){
  'use strict';
  return function(cart,eligibleIds,threshold,goal){
    var items=cart.items||[],physical=items.some(function(item){return item.requires_shipping;});
    var eligible=physical&&cart.currency==='USD'&&items.every(function(item){return item.requires_shipping&&eligibleIds.indexOf(String(item.product_id))!==-1;});
    var count=items.reduce(function(n,item){return n+(item.requires_shipping?item.quantity:0);},0);
    return {physical:physical,eligible:eligible,earned:eligible&&(cart.total_price>=threshold||(goal>0&&count>=goal)),remaining:Math.max(0,threshold-cart.total_price),count:count};
  };
});
